// eslint-disable-next-line import/no-unresolved
import type { Content } from '@plone/types';

export type ModuleCategory =
  | 'MandatoryProgram'
  | 'ElectiveProgram'
  | 'ElectiveMandatoryProgram';

export interface ModuleEntryData {
  '@id'?: string;
  module?: Content;
  category?: ModuleCategory;
}

export interface ModuleGroupData {
  '@id': string;
  title?: string;
  description?: string;
  showGroup?: boolean;
  /** Standard groups aggregate the page-property field of this category. */
  category?: ModuleCategory;
  /** Neutral migration group: entries parked from the pre-#1717 block. */
  modules?: ModuleEntryData[];
}

// Editors cannot delete the standard module types, only hide them (#1717)
const STANDARD_MODULE_GROUPS: ReadonlyArray<{
  '@id': string;
  category: ModuleCategory;
}> = [
  { '@id': 'mandatory', category: 'MandatoryProgram' },
  { '@id': 'electiveMandatory', category: 'ElectiveMandatoryProgram' },
  { '@id': 'elective', category: 'ElectiveProgram' },
];

export const STANDARD_MODULE_GROUP_IDS = STANDARD_MODULE_GROUPS.map(
  (group) => group['@id'],
);

export const LEGACY_MODULE_GROUP_ID = 'legacy';

export const defaultModuleGroups = (
  showGroup: boolean = true,
): Array<ModuleGroupData & { category: ModuleCategory }> =>
  STANDARD_MODULE_GROUPS.map((group) => ({ ...group, showGroup }));

// Page-property field per standard category (content/continuing_education.py).
export const CATEGORY_CONTENT_FIELDS = {
  MandatoryProgram: 'mandatory_programs',
  ElectiveMandatoryProgram: 'elective_mandatory_programs',
  ElectiveProgram: 'elective_programs',
} as const satisfies Record<ModuleCategory, string>;
